import React, { useMemo } from 'react';

import { useQualification } from 'qualification/context';
import { QUALIFICATION_STATUS } from 'qualification/context/model';
import { cateringCategoriesQuestion } from 'qualification/schema/questions/cateringCategoriesQuestion';
import { cityQuestion } from 'qualification/schema/questions/cityQuestion';
import useLocalizedFieldName from 'shared/hooks/useLocalizedFieldName';
import SystemCardSelect from 'system/components/CardSelect';
import { CardSelectOption } from 'system/components/CardSelect/CardSelectItem';

interface Props {
  question: typeof cityQuestion | typeof cateringCategoriesQuestion;
  multi?: boolean;
  orientation: 'vertical' | 'horizontal';
  displayOptions: number;
}

const CardSelect: React.FC<Props> = ({
  question,
  multi,
  orientation,
  displayOptions,
}) => {
  const { localizedAttributeName } = useLocalizedFieldName();
  const { actions, state, answerOf } = useQualification();

  const localizedOptions = useMemo((): CardSelectOption<string>[] => {
    if (state.status !== 'answering') {
      return [];
    }

    const items = question.getItems({
      answers: state.qualification.answers,
      selectedCaterer: state.qualification.selectedCaterer,
    });
    return items.map((option) =>
      'imageComponent' in option
        ? ({
            value: option.value as NonNullable<typeof option.value>,
            imageComponent: option.imageComponent as NonNullable<
              typeof option.imageComponent
            >,
            // @ts-expect-error TODO: function needs to be typed
            label: option[localizedAttributeName('label')] as string,
            // @ts-expect-error TODO: function needs to be typed
            subtitle: option[localizedAttributeName('subtitle')] as string,
          } as CardSelectOption<string>)
        : ({
            value: option.value as NonNullable<typeof option.value>,
            image: option.image,
            // @ts-expect-error TODO: function needs to be typed
            label: option[localizedAttributeName('label')] as string,
            // @ts-expect-error TODO: function needs to be typed
            subtitle: option[localizedAttributeName('subtitle')] as string,
          } as CardSelectOption<string>)
    );
  }, [question.getItems]);

  if (state.status !== QUALIFICATION_STATUS.answering) {
    return null;
  }

  const answer = answerOf(question.id);

  const handleChange = async (payload?: string) => {
    actions.answerQuestion(question.id, payload);
  };

  return (
    <div>
      <SystemCardSelect
        questionId={question.id}
        onClick={handleChange}
        selected={answer}
        options={localizedOptions}
        state={state}
        multi={multi}
        orientation={orientation}
        displayOptions={displayOptions}
      />
    </div>
  );
};

export default CardSelect;
